import { FormProvider } from 'react-hook-form';
import { useEditClient } from './hooks';
import { convertToCustomFieldDefinitions, convertToPresentationProps } from './logics';
import { EditClientPresentation } from './presentations';

type Props = {
  /** クライアントID（数値）*/
  clientId: number;
};

/**
 * 利用企業編集フォームのコンテナコンポーネント（新版）
 *
 * NOTE: Suspense を使用する hook を含むため、親コンポーネントで Suspense でラップしてください
 */
export const EditClient: React.FC<Props> = ({ clientId }) => {
  const {
    state: {
      methods,
      isButtonDisabled,
      clientName,
      prefectures,
      partnerBranches,
      groups,
      partnerFeatureFlags,
      clientData,
      customFieldDefinitions,
    },
    actions: { handleOnSubmit, handleCancel },
  } = useEditClient({ clientId });

  const { prefectureOptions, partnerBranchOptions, groupOptions, featureFlagOptions } =
    convertToPresentationProps({
      prefectures,
      partnerBranches,
      groups,
      clientData,
      partnerFeatureFlags,
    });

  return (
    <FormProvider {...methods}>
      <EditClientPresentation
        isButtonDisabled={isButtonDisabled}
        clientName={clientName}
        prefectureOptions={prefectureOptions}
        partnerBranchOptions={partnerBranchOptions}
        groupOptions={groupOptions}
        featureFlagOptions={featureFlagOptions}
        customFieldDefinitions={convertToCustomFieldDefinitions(customFieldDefinitions)}
        onSubmit={handleOnSubmit}
        onCancel={handleCancel}
      />
    </FormProvider>
  );
};
